<template>
  <v-card>
    <v-card-text>
      <v-layout>
        <v-flex xs12 md6 offset-md6>
          <v-select
            v-if="productClientOptions.length > 1"
            :items="productClientOptions"
            v-model="productClientFilter"
            label="Product List"
          ></v-select>
        </v-flex>
      </v-layout>
      <v-data-table
        :loading="loading"
        :items="filteredItems"
        :headers="headers"
        :itemsPerPage="100"
        hide-default-footer
        ref="coil-status-table"
        mobile-breakpoint="0"
      >
        <template v-slot:item="{ item }">
          <coil
            :item=item
          >
          </coil>
        </template>

        <template slot="no-data">
          <v-alert
            :value="noData"
            color="error"
            icon="warning"
          >
            Sorry, nothing to display here :(
          </v-alert>
        </template>
      </v-data-table>

      <v-fab-transition>
        <v-btn
          v-if="buttonShow && (!loading && !noData)"
          fixed
          dark
          fab
          bottom
          right
          color="pink"
          @click.native="copyTableToClipboard($refs[ 'coil-status-table' ].$el)"
        >
          <v-icon>content_copy</v-icon>
        </v-btn>
      </v-fab-transition>
    </v-card-text>
  </v-card>
</template>

<script>
  import domMixin from '@/mixins/dom'
  import productMixin from '@/mixins/product'

  // Components
  import Coil from '@/components/Common/Rental/Locations/Coil'

  export default {
    props: {
      loading: Boolean,
      location: Object,
    },

    mixins: [
      domMixin,
      productMixin
    ],

    components: {
      Coil
    },

    data () {
      return {
        headers: [
          {
            text: 'SKU',
            sortable: false,
            align: 'left'
          },
          {
            text: 'Coil',
            sortable: false,
            align: 'left'
          },
          {
            text: 'Capacity',
            sortable: false,
            align: 'left'
          },
          {
            text: 'Remain #',
            sortable: false,
            align: 'left'
          },
          {
            text: 'Fill #',
            sortable: false,
            align: 'left'
          },
          {
            text: 'Product',
            sortable: false,
            align: 'left'
          },
          {
            text: 'Price $',
            sortable: false,
            align: 'left'
          },
          {
            text: 'Expiry Date',
            sortable: false,
            align: 'left'
          }
        ],

        buttonShow: true,

        productClientFilter: null,
      }
    },

    watch: {
      show (value) {
        const buttonShowTimeout = value ? 1000 : 200

        setTimeout(() => {
          this.buttonShow = value
        }, buttonShowTimeout)
      }
    },

    computed: {
      items () {
        if (!this.location) {
          return []
        }
        return Object.values(this.location.coils)
      },

      filteredItems () {
        if (this.productClientFilter) {
          return this.items.filter(item => item.client === this.productClientFilter)
        }

        return this.items
      },

      productClientOptions () {
        return [ ...new Set(this.items.map(item => item.client)) ]
          .filter(option => {
            return option !== ''
          })
          .map(option => {
            if (option === null) {
              return {
                value: option,
                text: 'All',
              }
            }

            return {
              value: option,
              text: option[ 0 ].toUpperCase() + option.slice(1)
            }
          })
      },

      noData () {
        return !this.loading && this.items.length === 0
      },

      coilSettings () {
        if (!this.location || !this.location.coil_settings) {
          return [
            {
              name: 'A',
              value: '--'
            },
            {
              name: 'B',
              value: '--'
            },
            {
              name: 'C',
              value: '--'
            },
            {
              name: 'D',
              value: '--'
            },
            {
              name: 'E',
              value: '--'
            },
            {
              name: 'F',
              value: '--'
            }
          ]
        }

        const settings = []

        this.location.coil_settings.split(',').map((setting) => {
          const trimed = setting.trim()
          settings.push({
            name: trimed[ 0 ],
            value: trimed[ 1 ]
          })
        })

        return settings
      }
    }
  }
</script>

<style lang="stylus">
  .scale-transition
    &-enter-active, &-leave, &-leave-to
      transition: $primary-transition

    &-enter, &-leave-to
      transform: scale(0)

  .coil-settings-container
    display: flex
    flex-wrap: no-wrap
    justify-content: center
</style>



// WEBPACK FOOTER //
// src/components/Common/Location/Stock.vue